<template>
  <div :class="['process-content','process-editor', $route.query.menuType == 'researcher'? editorLayoutClass:'layout_type_4' ]">
<!--  <div class="layout_type_4">-->
    <!-- layout_type_1 : table 접히고 editor만 보임 -->
    <!-- layout_type_2 : editor 접히고 table만 보임 -->
    <!-- layout_type_4 : grid 없앰 -->
    <ProcessTop
        :readOnly="true"
        :experimentFlag="true"
    />
    <div ref="topPanel" class="topPanel">
      <IssueList
          :experimentFlag="true"
      />
      <ReadOnlyEditor/>
      <SideBar/>
      <ProcessReadOnlyBtmOption
          :processType="processType"
          :experimentFlag="true"
      />
      <ProcessReadOnlyDocumentOption
          :apiType="`process`"
      />
    </div>
    <div v-resizable="{ target: 'topPanel' }" class="divider">
      <div class="divider_btn"></div>
    </div>
    <ExperimentResult
      :editKey="editKey"
      :mode="mode"
      @editExperiment="editExperiment"
    />
    <Loading :visible="loading" />
  </div>
</template>

<script>
let num = 0;
import {ref, onMounted, watch} from 'vue'
import ProcessTop from '@components/processEditor/Top';
import SideBar from "@nav_process/SideBar";
import CommNew from "@processEditor/CommNew";
import TagOptionPopTagAddList from '@components/TagAddPop/TagOptionPopTagAddList' ;
import IssueList from '../protocolEditor/IssueList';
import ProcessReadOnlyBtmOption from '@common/ProcessReadOnlyBtmOption' ;
import ProcessReadOnlyDocumentOption from "@nav_process/Editor/ReadOnlyDocumentOption"
import ReadOnlyEditor from "@components/experimentResult/index_readonly";
import ExperimentResult from "@/components/experimentResult/ExperimentResult";
import Loading from '@common/loading.vue';

import {createNamespacedHelpers} from 'vuex';
const Hub = createNamespacedHelpers('Hub');
import {v4} from "uuid";

export default {
  mixins: [CommNew],
  components: {
    ExperimentResult,
    ProcessTop,
    ReadOnlyEditor,
    SideBar,
    TagOptionPopTagAddList,
    IssueList,
    ProcessReadOnlyBtmOption,
    ProcessReadOnlyDocumentOption,
    Loading,
  },
  data() {
    return {
      firstBln: false,
      readOnly: true,
      editKey: null,
      processType : null,
      mode : "readOnly",
      loading : false,
    }
  },
  computed: {
    editorLayoutClass() {
      return this.$store.getters["Hub/getEditorLayoutClass"];
    },
  },
  async mounted() {
    await this.releaseCheck(); //공개여부 체크
    //this.setProcessReadOnly(true);
    if (this.$route.query.processId == "NaN") {
      this.$router.push({path: `/process/gate`});
      return;
    }

    let {user, $route: {query}} = this;
    this.setInitInfo({user, query});
    await this.setProcess_N_UserInfo();
    await this.initElements();
    this.firstBln = true;
  },
  watch: {
    async PROCESS_INFO() {
      if (!this.firstBln) return;
      // console.log(' ------. this.firstBln : ' , this.firstBln ) ;
      await this.releaseCheck() //공개여부 체크
    },
    editorLayoutClass: {
      immediate: true, // 컴포넌트 생성 시 즉시 실행
      handler(newValue) {
        this.$nextTick(() => {
          // DOM이 업데이트된 후 실행
          if (this.$refs.topPanel) {
            if (newValue === 'layout_type_1') {
              // layout_type_1일 경우 height 스타일 제거
              this.$refs.topPanel.style.removeProperty('height');
            } else {
              // 그 외의 경우 필요한 높이 설정
            }
          }
        });
      }
    }
  },
  methods: {
    ...Hub.mapMutations(
        [
          "setSelectedReleaseProcess","setExperimentResultMode"
        ]
    ),
    async releaseCheck() {
      try {
        this.loading = true;

        if (this.$route.query.menuType != "researcher") {
          this.loading = false;
          alert('잘못된 접근입니다.');
          this.$router.push({
            path: '/experiment/gate',
            query: {
              editorType: 'gate'
            }
          });
          return;
        }

        const targetProcess = await this.$wApi.process.release.get({
          processId : this.$route.query.processId
        });

        if(!targetProcess.idReleaseProcess ){
          window.alert(`<span class='text-14 fw-400'>공개한 공정도가 아닙니다.</span> <h6 class='text-16 fw-600 mt-1' style='text-align:center;'>공정도목록으로 이동합니다.</h6>`,{
              okTitle: "확인",
              okVariant: "platform",
            });
          this.editorType = 'gate';
          this.$router.push({
            path : '/experiment/gate', query : {editorType : 'gate'}
          });
        }else{
          this.setSelectedReleaseProcess(targetProcess)
        }
      }catch (e){
        alert(e);
      }finally {
        this.loading = false;
      }
    },
    async editExperiment() {
      try {
        const key = v4();
        let keyResponse;
        //console.log('this.editKey = {}',this.editKey)
        const response = await this.$wApi.simultaneous.editCheck({
          relativeId: this.$route.query.processId,
          editType: "EXPERIMENT",
          validTime: Math.floor(this.editDuration / 1000),
        });
        if (response.isEditMode) {
          if (this.user.id == response.userResBody.id && response.editKey != null && response.editKey != "" && response.count == 0 && !response.editable) {
            //유저가 같음 && editStatus가 신규 상태가 아님 && 유효시간 지난 status가 없음(수정중! count=0) && editable == false => 어느 세션 유지할건지 confirm
            const confirmResult = await confirm("다른 브라우저에서 수정중입니다.<br/> 수정화면을 대체하시겠습니까?");
            if (confirmResult) {
              //key 발급(update)
              keyResponse = await this.$wApi.simultaneous.statusUpdate({
                relativeId: this.$route.query.processId,
                editType: "EXPERIMENT",
                editKey: key,
                editable: false, //수정불가능상태로 변경
              });
            } else {
              //수정불가
              this.mode = "readOnly";
              this.setExperimentResultMode(this.mode);
              return;
            }
          } else {
            //수정가능 상태이거나 또는 유저가 다르거나 또는 editStatus가 신규 상태 또는 유효시간 지났을경우 => key 발급(update).
            keyResponse = await this.$wApi.simultaneous.statusUpdate({
              relativeId: this.$route.query.processId,
              editType: "EXPERIMENT",
              editKey: key,
              editable: false, //수정불가능상태로 변경
            });
          }
          //수정가능
          if (!keyResponse.error) {
            this.editKey = key;
            this.mode = "edit";
            this.setExperimentResultMode(this.mode);
          }
        } else {
          //수정불가
          this.mode = "readOnly";
          this.setExperimentResultMode(this.mode);
          alert(`현재 ${response.userResBody.userName}님이 수정중입니다.`)
        }
      } catch (e) {
        this.mode = "readOnly";
        this.setExperimentResultMode(this.mode);
        console.log(e);
      }
    },
  },
}
</script>

<style lang="scss">
.process-editor .process-editor-top {
  grid-area: top;
}
</style>

<style lang="scss" scoped>
  @import "@/style/new/css/cyl.common.css";
</style>